import React, { useState, useContext, useEffect } from "react";
import { Slide } from './Slide';
import { User } from "../models/User";
import { WrapperContext } from "../context/WrapperContext";
import { Matches } from '../user/Matches';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import { AppContext } from '../window';
import FavoriteIcon from '@mui/icons-material/Favorite';
import SwipeIcon from '@mui/icons-material/Swipe';
import { useSliderRouting } from './useSliderRouting';

export enum ModalType {
  Favorite = "favorite",
  Match = "match",
  Pay = "pay",
  NoPicture = "noPicture"
}


export interface State {
  user: User | undefined | null;
  modal: ModalType | undefined;
  setUser: any;
  setModal: any;
  legacyMode: boolean;
}

export const SliderContext = React.createContext({
  user: undefined,
  modal: undefined,
  setUser: (_user: User) => {},
  setModal: (_modal: ModalType) => {},
  legacyMode: false
} as State);

interface SliderProps {
  showTabNavigation?: boolean;
  legacyMode?: boolean;
}

export const Slider: React.FC<SliderProps> = ({ showTabNavigation = true, legacyMode = false }) => {
  const [user, setUser] = useState<User | undefined>(undefined);
  const [modal, setModal] = useState<ModalType | undefined>(undefined);
  const { activeTab, navigateToTab } = useSliderRouting();
  const { setWrapperClasses } = useContext(WrapperContext);
  const { texts } = useContext(AppContext);

  useEffect(() => {
    // Set the required classes when the slider component mounts
    setWrapperClasses('d-flex flex-column vh-100');

    // Clear the classes when the component unmounts
    return () => {
      setWrapperClasses('');
    };
  }, [setWrapperClasses]);

  return (
    <SliderContext.Provider value={{ 
      user, 
      modal, 
      setUser, 
      setModal,
      legacyMode
    }}>
      <>
        {/* Tab Navigation */}
        {showTabNavigation && (
          <ButtonGroup className="p-1 col-lg-6 offset-lg-3 col-xl-4 offset-xl-4">
            <Button
              variant={activeTab === 'match' ? "primary" : "outline-primary"}
              onClick={() => navigateToTab('match')}
              className="fw-medium"
            >
              <SwipeIcon className="me-1" fontSize="small" />
              {texts?.matchTab || 'Match'}
            </Button>
            <Button
              variant={activeTab === 'matches' ? "primary" : "outline-primary"}
              onClick={() => navigateToTab('matches')}
              className="fw-medium"
            >
              <FavoriteIcon className="me-1" fontSize="small" />
              {texts?.matchesTab || 'Matches'}
            </Button>
          </ButtonGroup>
        )}

        {/* Tab Content */}
        {showTabNavigation ? (
          activeTab === 'match' ? (
            <Slide />
          ) : (
            <div className="overflow-auto">
              <Matches />
            </div>
          )
        ) : (
          <Slide />
        )}
      </>
    </SliderContext.Provider>
  );
};
